import { useQuery } from '@tanstack/react-query';
import { tagsApi } from '../lib/api';

// Contratto API: GET /api/v1/tags/kpi
export interface TagKpiCategory {
  category: string;
  count: number;
  // Timestamp dell'ultima mail nella categoria (ISO) o null se assente
  last_at?: string | null;
}
export interface TagKpiTag {
  id: string;
  name: string;
  color: string;
  count: number;
}
export interface TagKpi {
  categories: TagKpiCategory[];
  tags: TagKpiTag[];
  total_messages: number;
}

// Hook KPI tag: categorie (poche) + tag principali con conteggio.
export function useTagKpi() {
  return useQuery({
    queryKey: ['tag-kpi'],
    queryFn: async () => {
      const res = await tagsApi.kpi();
      // Difensivo: normalizza eventuali wrapper/campi mancanti
      return {
        categories: res?.categories ?? [],
        tags: res?.tags ?? [],
        total_messages: res?.total_messages ?? 0,
      } as TagKpi;
    },
  });
}
